import { Pipe, PipeTransform } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs/internal/Observable';
import { SimpleVideo } from '@portal/models/simpleVideo';
import { VideoPosterService } from './video-poster.service';

@Pipe({
  name: 'videoPoster',
  pure: true,
  standalone: true,
})
export class VideoPosterPipe implements PipeTransform {
  constructor(private readonly posterService: VideoPosterService) {}

  transform(value?: SimpleVideo | string | null): Observable<SafeUrl | null> {
    return this.posterService.getPoster(value);
  }
}
